import { Calendar, DatePicker, setupCalendar } from '@angelblanco/v-calendar'
import '@angelblanco/v-calendar/style.css'

export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp
  // Use plugin defaults (optional)
  app.use(setupCalendar, {})

  // Use the components
  app.component('VCalendar', Calendar)
  app.component('VcDatePicker', DatePicker)
})
